import * as React from "react";
import type { Status } from "@/types";

interface StatusBadgeProps {
  status: Status
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const styles = {
    backgroundColor: status.bgColour,
    color: status.txtColour
  }
  return <div className="status-badge" style={styles}>{status.name}</div>;
};

